

// import { ThreeDots } from 'react-loader-spinner'
import './LogoLoader.css'
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';

const override = `
  display: block;
  margin: 0 auto;
  border-color: red;
`;

export const LogoLoader = ({Data}) => {
  return (
    <main className="mainLoader" >
      <p className="loader_back">
        <img src={Data?.logoPhoto} alt="" className="img_size " style={{borderRadius:'50%'}}/>
        <span className="preloader"></span>
      </p>
    </main>
  )
}


export const Loading = () => {
  return (
    <Loader fullPage loading />
  )
}

// export default function BeatLoaderfn({ customcolor }) {
//   return (
//     <BeatLoader color={'#293990'} css={override} size={10} />
//   )
// }


// export const ButtonLoader = () => {
//   return (
//     <>
//       <i
//         className="fa fa-spinner fa-spin"
//       // style={{ marginRight: "0px" }}
//       />
//     </>
//   )
// }

// export const ThreeLoading = () => {
//   return (
//     <ThreeDots
//       visible={true}
//       height="40"
//       width="40"
//       color="#293990"
//       radius="9"
//       ariaLabel="three-dots-loading"
//       wrapperStyle={{}}
//       wrapperClass=""
//     />
//   )
// }

